import gsap from 'gsap';
import emitter from 'tiny-emitter/instance';

class SplitTextEffect{
    constructor() {
        this.initSplitText()
        emitter.on('barba::after', this.initSplitText, this)
    }

    setupLinks(){
        this.menuLinks = document.querySelectorAll('nav .menu-menu-footer-container .menu-item a')
        this.menuLinks.forEach(el=>{
            el.classList.add('js-split-char')
        })
    }

    initSplitText(){
        this.setupLinks()
        this.$words = document.querySelectorAll('.js-split-char')
        this.splitText()
        this.bindEvents()
    }

    bindEvents(){
      // eslint-disable-next-line no-unused-vars
        this.$words.forEach((el,index)=>{
          // eslint-disable-next-line no-unused-vars
            el.addEventListener('mouseenter',(evt)=>{
                this.splitAnimation(el)
            })
        })

    }

    splitText(){

        this.$words.forEach(el=>{

            let txtSpan = ''
            let txt = el.textContent
            txt.split('').forEach(content =>{
                txtSpan += `<span>${content}</span>`
            })
            el.innerHTML = txtSpan
        })
    }


    splitAnimation(el){
        this.$letters = el.querySelectorAll( 'span')

        for (let i = this.$letters.length - 1; i>= 0; i--){
            let $el = this.$letters[i]
            let delay = 0.03 * i

            gsap.to($el,{
                duration:0.2,
                ease: 'power1.in',
                delay: delay,
                yPercent:'-50',
                onComplete:function (){
                    gsap.set($el, {
                        yPercent: '50',
                    });
                    gsap.to($el,  {
                        duration: 0.3,
                        ease: 'power1.out',
                        opacity: 1,
                        yPercent: '0',
                    });
                }})

        }
    }

}

export default SplitTextEffect



// WEBPACK FOOTER //
// ./scripts/utils/effects/splitTextEffect.js